import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../services/authentication.service';
import { SESSION_ID, TOKEN_NAME } from '../constants/authentication.constants';
import { Observable, tap } from 'rxjs';
import { WindowService } from '../services/window.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private windowService: WindowService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.log(`---> Intercepting the call... IsLoggedIn: ${this.authenticationService.isLoggedIn}\nRequest: ${JSON.stringify(req)}`);
    if (this.authenticationService.isLoggedIn) {
      //console.log(`---> Interceptor is calling: ${req.url}`);

      const sessionId = this.windowService.getSessionIdFromWindow() ?? '';
      let headersWithToken = req.headers.append(SESSION_ID, sessionId);
      //console.log(`---> Interceptor found SessionId: ${sessionId}`);

      const cookies = document.cookie.split(';');
      let aiSessionCookie;
      for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name.trim() === 'ai_session') {
          aiSessionCookie = value;
          break;
        }
      }
      if (aiSessionCookie) {
        this.authenticationService.setAISession(aiSessionCookie);
      }

      req = req.clone({
        withCredentials: true,
        headers: headersWithToken,
      });

      // Reset the timer which keeps track of inactivity
      // Don't reset the timer when the Maintenance request is being sent
      if (
        !this.isMatchingEndpoint(req.url.toLowerCase(), '/maintenance') &&
        !this.isMatchingEndpoint(req.url.toLowerCase(), '/autologin/create')
      ) {
        this.authenticationService.setExpiryTimeout();
      }
    }

    return next.handle(req).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // Handle successful responses here, if needed
            //console.log(`---> Intercepted response: ${JSON.stringify(event)}`);
          }
        },
        error: (err: any) => {
          //console.log(`---> Intercepted error: ${JSON.stringify(err)}`);
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401 && !this.isMatchingEndpoint(req.url.toLowerCase(), '/login')) {
              // Log out the user and redirect to the LoggedOut page
              // Except on the login request
              this.logout();
            }
          }
        },
      })
    );
  }

  private logout(): void {
    this.authenticationService.handleLogout(false);
  }

  private isMatchingEndpoint(url: string, endpoint: string) {
    return url == environment.endpoints.apiUrl + endpoint;
  }
}
